<template>

    <panel-navigation>
        <div>
            <h1 class="text-lg font-semibold mb-4">Resources</h1>

            <hr class="border-b border-gray-100 mb-3">

                <strong>Review Postcard Template For Marketing Agencies</strong><br />
                <a target="_BLANK" href="https://www.canva.com/design/DAE9Is8wxvA/JvRGOa-6tT2YO6ZaETclfA/view?utm_content=DAE9Is8wxvA&utm_campaign=designshare&utm_medium=link&utm_source=sharebutton&mode=preview">https://www.canva.com/design/DAE9Is8wxvA/JvRGOa-6tT2YO6ZaETclfA/view?utm_content=DAE9Is8wxvA&utm_campaign=designshare&utm_medium=link&utm_source=sharebutton&mode=preview</a>
                <br /><br />

                <strong>Canva image links</strong><br />
                <a target="_BLANK" href="https://docs.google.com/document/d/19qFSQxLSuTpPibpRe7snnXV1I6NgYfiWu9VWBG1UnRA/edit">https://docs.google.com/document/d/19qFSQxLSuTpPibpRe7snnXV1I6NgYfiWu9VWBG1UnRA/edit</a>
                <br /><br />

                <strong>Reputation Onboarding Call Slides</strong><br />
                <a target="_BLANK" href="https://drive.google.com/file/d/1zbq0s3C-mp0uMuVRyd5jK8p2-U33SgHR/view">https://drive.google.com/file/d/1zbq0s3C-mp0uMuVRyd5jK8p2-U33SgHR/view</a>
                <br /><br />

                <strong>100+ Review & Reputation Quotes</strong><br />
                <a target="_BLANK" href="https://docs.google.com/spreadsheets/d/1Z05sR_nEWZqYNNCAsZKFcRgIXqnHGMap9TwHK7lSupg/edit#gid=0">https://docs.google.com/spreadsheets/d/1Z05sR_nEWZqYNNCAsZKFcRgIXqnHGMap9TwHK7lSupg/edit#gid=0</a>
                <br /><br />

                <strong>Slide Deck Template</strong><br />
                <a target="_BLANK" href="https://docs.google.com/presentation/u/1/d/16k7EApP8Qk78hzqXRIyKDuiP4LvNN8O7f4HMRa94Flg/copy">https://docs.google.com/presentation/u/1/d/16k7EApP8Qk78hzqXRIyKDuiP4LvNN8O7f4HMRa94Flg/copy</a>
                <br /><br />
            </div>
    </panel-navigation>
</template>

<script>
import PanelNavigation from '@/components/PanelNavigation.vue'

export default {
  metaInfo () {
    return {
      title: "Resources | " + this.$appName
    }
  },
  components: {
    PanelNavigation
  },
}
</script>